import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom'
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery } from '@tanstack/react-query';
import ImageWithLoader2 from './components/ImageWithLoader2';
import './styles/memorial-v2.css';

function FamilyMembersDeceased() {
    
    const { menu, toggleMobileMenu } = useAppLayout();

    const navigate = useNavigate();

  const { data: members, isLoading, isError } = useQuery({
    queryKey: ['deceasedMembers'],
    queryFn: () =>
      axios.get(`${API_URL}/family-members-deceased`, { withCredentials: true }).then((response) => response.data),
    staleTime: 0,
    cacheTime: Infinity,
  });

  const fmt = (d) => {
    if (!d) return '';
    const x = new Date(d);
    return Number.isNaN(x)
      ? d
      : x.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
  };

  const scriptName = (m) => [m?.n_prefix, m?.name, m?.last_name].filter(Boolean).join(' ').trim();


    return (
         
      <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
      <Header onMenuClick={(value) => toggleMobileMenu()} />
      <Sidebar />


         <div className='page-wrapper' >
         <div className='content container-fluid' >
 
          <div className="row g-4">
                        {isLoading ? (
                          <div className="loadingspinnerDiv">
                            <div className="loadingspinner"></div>
                          </div>
                        ) : isError ? (
                          <p>Error fetching deceased family members.</p>
                        ) : members?.length ? (
                          members.map((m) => (
                            <div key={m.user_id} className="col-12 col-lg-4 d-flex justify-content-center">
                              <article
                                className="memorial-card-v3 clickable-card"
                                onClick={() => navigate('/profile', { state: { memberId: m.id } })}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    navigate('/profile', { state: { memberId: m.id } });
                                  }
                                }}
                              >
                                <div className="memorial-card-v3-corner memorial-card-v3-corner-tl" />
                                <div className="memorial-card-v3-corner memorial-card-v3-corner-br" />
          
                                <h2 className="memorial-card-v3-title">
                                  IN LOVING MEMORY
                                  <i className="fas fa-dove memorial-card-v3-dove" aria-hidden="true" />
                                </h2>
          
                                <div className="memorial-card-v3-photo-wrap">
                                  {m?.profile_image ? (
                                    <ImageWithLoader2
                                      src={`${API_URL}/images/${m.profile_image}`}
                                      placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
                                      fadeDuration={800}
                                      blurAmount={15}
                                      alt={scriptName(m) || 'Portrait'}
                                      className="memorial-card-v3-photo"
                                    />
                                  ) : (
                                    <div className="memorial-card-v3-photo-placeholder">[Memorial Photo]</div>
                                  )}
                                </div>
          
                                <h3 className="memorial-card-v3-name">{scriptName(m) || 'Unknown'}</h3>
          
                                <div className="memorial-card-v3-dates">
                                  <span>BORN: {fmt(m?.date_of_birth) || 'Unknown'}</span>
                                  <span>DIED: {fmt(m?.date_of_death) || 'Unknown'}</span>
                                </div>
          
                                <p className="memorial-card-v3-epitaph">Forever in our hearts</p>
          
                                <button
                                  type="button"
                                  className="memorial-card-v3-btn"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate('/profile', { state: { memberId: m.id } });
                                  }}
                                >
                                  Tributes -&gt;
                                </button>
                              </article>
                            </div>
                          ))
                        ) : (
                          <p>No deceased family members found.</p>
                        )}
                      </div>

    </div>
    </div>

</div>

    );
}

export default FamilyMembersDeceased;
